import React from 'react';

// receptionist
import Dashboard_Reception from './views/Reception/Dashboard/index';
import Dashboard_ExternalReception from './views/ExternalReception/Dashboard/ScanQR';
import ViewAllCheckIn_Reception from './views/Reception/ViewAllCheckIn';
import VisitorCount_Reception from './views/Reception/VisitorCount';
import History from './views/Reception/History';
import Overdue from './views/Reception/Overdue/Overdue';
import Home_Reception from './views/Reception/Home';

// host
import Dashboard_Host from './views/Host/Dashboard';
// import All_Meeting_Host from './views/Host/ViewAll';
import All_Meeting_Host from './views/Host/ViewAllPublicLayer';

// corporate
import Dashboard_Corporate from './views/Corporate/Dashboard';
import Manage_Corporate from './views/Corporate/ManageCop/update/index';
import Manage_System_Users from './views/Corporate/ManageSystemUsers/index';
import Manage_VIP_Users from './views/Corporate/Users/VIPManage/index';
import Login_Details from './views/Corporate/LoginDetails/index';
import Department_Corporate from './views/Corporate/ManageCop/Department';
import Summary_Report from './views/Corporate/SummaryReport/index';
import Success_Failed_Visitor from './views/Corporate/SuccessFailedVisitor/index';
import Widgets_Visitors from './views/Corporate/WidgetsForVisitorsReport/index';
import Receptionist_Summary_Report from './views/Corporate/ReceptionistSummaryReport/index';
import Manage_Building_Corporate from './views/Corporate/Locations/ManageBuilding/ManageBuilding';
import Manage_User_Groups from './views/UserGroups';


import Branches_Corporate  from './views/Corporate/Branches/';
import Location_Corporate from './views/Corporate/Locations/CreateLocation/index';
import ViewAllLocations from './views/Corporate/Locations/ViewAll';

import CreateUsers_Corporate from './views/Corporate/Users/CreateUser';
import Create_Corporate_User from './views/Corporate/Users/CreateCoparateUser/index';
import ViewAllUsers_Corporate from './views/Corporate/Users/ViewAll';
import View_SMS from './views/Corporate/Reports/ViewSMS/ViewSMS';

import Single_User_Notification from './views/Corporate/PushNotifications/SetNotifications'
import Category_Notification from './views/Corporate/PushNotifications/CategoryNotifications'

import User_Categorization from './views/Corporate/UserCategorization'

// corporate visitorTags
import VisitorDashboard_Corporate from './views/Corporate/Dashboard/visitorTag';
import Receptions_Corporate from './views/Corporate/Receptions';
import Wifi_Corporate from './views/Corporate/VisitorTag/WifiPackages';
import Card_Corporate from './views/Corporate/VisitorTag/Cards';
import QRCheckinHistory from './views/Corporate/Reports/Visitortags/QRCheckin/QRCheckin';

/*ivca*/
import IVCAViewAllCamera from './views/Corporate/IVCA/ManageCamera/CameraView/CameraViewAll';
import IVCACreateCamera from './views/Corporate/IVCA/ManageCamera/CameraCreate/CameraCreate';

// super
import Dashboard_Super from './views/Super/Dashboard';
import AddModifyCorporate_Super from './views/Super/ManageCorporate/Add/AddCorporate';
import ViewAllCorporate_Super from './views/Super/ManageCorporate/ViewModify/ViewAllCorporate';
import AddCorporate_Admin from './views/Super/ManageCorporate_Admin/Add/AddCorporateAdmin';
import ViewCorporate_Admin from './views/Super/ManageCorporate_Admin/ViewModify/ViewCorporateAdmin';
import System_Admin from './views/Super/SystemAdmin/Add/index';
import Modify_System_Admin from './views/Super/SystemAdmin/ViewModify/ViewSysAdmin';
import View_Meeting_Report from './views/Super/Report/Super_ViewMeetingsReport';
import ViewTempCorporates from "./views/Super/ManageCorporate/TemporyList/TemporyList";

// super --> visitortags
import Dashboard_Super_Visitor from './views/Super/Dashboard/VisitorTag';

import Comming_Soon from './components/CommingSoon/CommingSoon';

// park
// import ParkTag_Home from './containers/ParkTag/Dashboard';

//Event
import Dashboard_Event from './views/Event/Dashboard';
import Organizer_Event from './views/Event/CorporateEventOrganizer';
import Manage_Event from './views/Event/ManageEvent/AddViewModify/index';
import SessionFeedbacks from './views/Event/ManageEvent/AddViewModify/Feedbacks/SessionFeedbacks/sessionFeedback';
import SpeakerFeedbacks from './views/Event/ManageEvent/AddViewModify/Feedbacks/SpeakerFeedback/speakerFeedback';
import Create_Event_Notification from './views/Event/PushNotifications/SetNotifications/index';
import View_Event_Notifications from './views/Event/PushNotifications/ViewNotifications/index';

//Event Organizer

import Dashboard_Event_Organizer from './views/EventOrganizer/Dashboard/index';
import Event_Participant_Count from './views/EventOrganizer/View-Count_participants/index';
import Participant_Questions from './views/EventOrganizer/QuestionBank/Question';
import Open_Screen from './views/EventOrganizer/OpenScreen/Screen';
import Checked_Participants from './views/EventOrganizer/CheckedParticipants/checkedParticipant';
import Manage_Participants from './views/EventOrganizer/ManageParticipants/ManageParticipant';
import * as routeConstants from "./const/route/Route";

// guest
import GuestProfile from './views/Guest/Profile/Profile';
import GuestDashboard from './views/Guest/Dashboard/Dashboard';
import GuestRegister from './views/Guest/Login/Register/Register';
// hr
import HRCorpBranches from './views/HR/ViewBranches/ViewBranches';

// space
import WorkSpace from './views/Space';
import WorkSpaceNotification from "./views/Space/Notifiction";

const routes = [

  // only parktag
  // { path: '/home', name: 'Home ️', component: Home_Reception },

  // reception
  { path: '/reception/home', name: 'Home ️', component: Home_Reception },
  { path: '/reception/dashboard', name: 'Schedule Meeting ️', component: Dashboard_Reception },
  { path: '/reception/checkout', name: 'To Check out ️', component: ViewAllCheckIn_Reception },
  { path: '/reception/visitorcount', name: 'Visitor Count ️', component: VisitorCount_Reception },
  { path: '/reception/history', name: 'Visitors History ️', component: History },
  { path: '/reception/overdue', name: 'Overdue Visitors ️', component: Overdue },

  // external-reception
  { path: '/external-reception/dashboard', name: 'Schedule Meeting ️', component: Dashboard_ExternalReception },
  { path: '/external-reception/checkout', name: 'To Check out ️', component: ViewAllCheckIn_Reception },
  { path: '/external-reception/visitorcount', name: 'Visitor Count ️', component: VisitorCount_Reception },
  { path: '/external-reception/history', name: 'Visitors History ️', component: History },
  { path: '/external-reception/overdue', name: 'Overdue Visitors ️', component: Overdue },


  // host
  // { path: '/reception/home', name: 'Home ️', component: Home_Reception },
  { path: '/host/dashboard', name: 'Schedule Meeting ️', component: Dashboard_Host },
  { path: '/host/allmeetings', name: 'All Meeting ️', component: All_Meeting_Host },
  // { path: '/reception/checkout', name: 'To Check out ️', component: ViewAllCheckIn_Reception },

  // corporate
  { path: '/corporate/dashboard', name: 'Dashboard', component: Dashboard_Corporate },
  { path: '/corporate/manage', name: 'Manage Corporate', component: Manage_Corporate },
  { path: '/corporate/department', name: 'Manage Departments', component: Department_Corporate },
  { path: '/corporate/branch', name: 'Manage Branches', component: Branches_Corporate },
  { path: '/corporate/locations/manage', name: 'Create Locations', component: Location_Corporate },
  { path: '/corporate/building/manage', name: 'Manage Buildings', component: Manage_Building_Corporate },
  { path: '/corporate/locations/view', name: 'View All Locations', component: ViewAllLocations },

  { path: '/corporate/users/create', name: 'Create Public Users', component: CreateUsers_Corporate },
  { path: '/corporate/users/create_corporate', name: 'Create Corporate Users', component: Create_Corporate_User },
  { path: '/corporate/users/view', name: 'View All Corporate Users', component: ViewAllUsers_Corporate },

  { path: '/corporate/systemusers', name: 'Manage System Users', component: Manage_System_Users },
  { path: '/corporate/VIPManage', name: 'Manage VIP Users', component: Manage_VIP_Users },

  { path: '/corporate/report/view_sms', name: 'View SMS', component: View_SMS },
  { path: '/corporate/report/logindetails', name: 'Login Details', component: Login_Details },
  { path: '/corporate/report/summaryreport', name: 'Summary Report', component: Summary_Report },
  { path: '/corporate/report/successfailedvisitor', name: 'Success Failed Visitor', component: Success_Failed_Visitor },
  { path: '/corporate/report/widgetsvisitors', name: 'Widgets For Visitors Report', component: Widgets_Visitors },
  { path: '/corporate/report/receptionistssummaryreport', name: 'Summary Report Of Receptionists', component: Receptionist_Summary_Report },

  { path: '/corporate/notifications/single/create', name: 'Single User Notification', component: Single_User_Notification },
  { path: '/corporate/notifications/category/create', name: 'Category Notification', component: Category_Notification },

  { path: '/corporate/user-categorization', name: 'User Categorization', component: User_Categorization },

  { path: '/corporate/usergroups', name: 'All User Groups Of Corporate', component: Manage_User_Groups },

  // corporate visitorTag
  { path: '/corporate/visitorTag/dashboard', name: 'Dashboard', component: VisitorDashboard_Corporate },
  { path: '/corporate/visitorTag/receptions', name: 'Manage Receptions', component: Receptions_Corporate },
  { path: '/corporate/visitorTag/checkIn', name: 'View CheckIn Visitors', component: Dashboard_Reception },
  { path: '/corporate/visitorTag/checkOut', name: 'View CheckIn Visitors', component: ViewAllCheckIn_Reception },
  { path: '/corporate/visitorTag/totalVisitors', name: 'View Total Visitors', component: VisitorCount_Reception },
  { path: '/corporate/visitorTag/overDue', name: 'View OverDue Visitors', component: Overdue },
  { path: '/corporate/visitorTag/history', name: 'View Visiting History', component: History },
  { path: '/corporate/visitorTag/wifiPackages', name: 'Manage Wifi Packages', component: Wifi_Corporate },
  { path: '/corporate/visitorTag/card', name: 'Manage Cards', component: Card_Corporate },
  { path: '/corporate/visitorTag/report_meeting', name: 'View Meetings - Report', component: View_Meeting_Report },
  { path: '/corporate/visitorTag/view_visitors', name: 'View Visitors', component: History }, // same
  { path: '/corporate/visitortags/qr-check-in', name: 'QR Check-in Visitors', component: QRCheckinHistory },

  /*iVCA*/
  { path: '/corporate/ivca/camera-onboard/create', name: 'Create Camera', component: IVCACreateCamera },
  { path: '/corporate/ivca/camera-onboard/view', name: 'View All Cameras', component: IVCAViewAllCamera },

  // super
  { path: '/super/dashboard', name: 'Dashboard', component: Dashboard_Super },
  { path: '/super/corporate', name: 'Manage Corporates', component: Dashboard_Super },

  // add/modify/view corporates
  { path: '/super/create_corporate', name: 'Create Corporate', component: AddModifyCorporate_Super },
  { path: '/super/view_corporates', name: 'View All Corporates', component: ViewAllCorporate_Super },

  // add/modify/view corporate admin
  { path: '/super/create_corp_admin', name: 'Create Corporate Administrator', component: AddCorporate_Admin },
  { path: '/super/view_corp_admin', name: 'View All Corporate Administrators', component: ViewCorporate_Admin },
  { path: '/super/pending-approval', name: 'Pending Approval', component: ViewTempCorporates },

  { path: '/super/corp_admin', name: 'Manage Corporate Administrators', component: Dashboard_Super },
  { path: '/super/sys_admin', name: 'Create System Administrators', component: System_Admin },
  { path: '/super/view_sys_admin', name: 'Modify System Administrators', component: Modify_System_Admin },
  { path: '/super/view_sms', name: 'View SMS', component: View_SMS },
  { path: '/super/login-details', name: 'Login Details', component: Login_Details },
  { path: '/super/summary-report', name: 'Summary Report', component: Summary_Report },
  { path: '/super/successfailedvisitor', name: 'Success Failed Visitor', component: Success_Failed_Visitor },
  { path: '/super/widgetsvisitors', name: 'Widgets For Visitors Report', component: Widgets_Visitors },
  { path: '/super/receptionistssummaryreport', name: 'Summary Report Of Receptionists', component: Receptionist_Summary_Report },

  // super --> visitortag
  { path: '/super/visitorTag/dashboard', name: 'Dashboard', component: Dashboard_Super_Visitor },
  { path: '/super/log', name: 'System Logs', component: Comming_Soon },
  { path: '/super/report', name: 'Reports', component: Comming_Soon },
  { path: '/super/report_meeting', name: 'View Meetings - Report', component: View_Meeting_Report },

  //Event(Routes for Eventtags)

  // event admin <-- EventOrganizer
  { path: '/eventtags/eventorganizer/dashboard', name: 'Event Check-In', component: Dashboard_Event_Organizer },
  { path: '/eventtags/eventorganizer/checked-participants', name: 'Registered Participants', component: Event_Participant_Count},
  { path: '/eventtags/eventorganizer/question-bank', name: 'Question Bank', component: Participant_Questions },
  { path: '/eventtags/eventorganizer/screen', name: 'Display Latest Question', component: Open_Screen },
  //----

  { path: '/eventtags/dashboard', name: `Dashboard`, component: Dashboard_Event},
  { path: '/eventtags/eventorganizer', name: 'Manage Event Organizer', component: Organizer_Event},
  // { path: '/eventtags/publicspeaker', name: 'Manage Public Speaker', component: Public_Speaker},
  { path: '/eventtags/events', name: 'Events', component: Manage_Event},
  { path: '/eventtags/notifications/create', name: 'Send Event Notifications', component: Create_Event_Notification},
  { path: '/eventtags/notifications/view', name: 'View Event Notifications', component: View_Event_Notifications},
  { path: '/eventtags/subeventfeedbacks', name: 'Sub Event Feedbacks', component: SessionFeedbacks},
  { path: '/eventtags/speakerfeedbacks', name: 'Speaker Feedbacks', component: SpeakerFeedbacks},
  // { path: '/eventtags/create_event/main_view', name: 'Create Event', component: Manage_Event_Add_Event_main_view},

  //Event tags corporate
  { path: '/corporate/eventtags/dashboard', name: `Dashboard`, component: Dashboard_Event},
  { path: '/corporate/eventtags/eventorganizer', name: 'Manage Event Organizer', component: Organizer_Event},
  { path: '/corporate/eventtags/events', name: 'Events', component: Manage_Event},
  { path: '/corporate/eventtags/notifications/create', name: 'Send Event Notifications', component: Create_Event_Notification},
  { path: '/corporate/eventtags/notifications/view', name: 'View Event Notifications', component: View_Event_Notifications},
  { path: '/corporate/eventtags/subeventfeedbacks', name: 'Sub Event Feedbacks', component: SessionFeedbacks},
  { path: '/corporate/eventtags/speakerfeedbacks', name: 'Speaker Feedbacks', component: SpeakerFeedbacks},

  { path: '/corporate/eventtags/event-checkin', name: 'Event Check-In', component: Dashboard_Event_Organizer },
  { path: '/corporate/eventtags/event-participants', name: 'Event Paricipants', component: Dashboard_Event_Organizer },
  { path: '/corporate/eventtags/checked-participants', name: 'Registered Participants', component: Event_Participant_Count},
  { path: '/corporate/eventtags/all-event-checked-participants', name: 'Checked Participants', component: Checked_Participants},
  { path: '/corporate/eventtags/event-question-bank', name: 'Question Bank', component: Participant_Questions },
  { path: '/corporate/eventtags/eventorganizer/screen', name: 'Display Latest Question', component: Open_Screen },

  //EventOrganizer
  { path: '/eventorganizer/dashboard', name: 'Event Check-In', component: Dashboard_Event_Organizer },
  { path: '/eventorganizer/manage-participants', name: 'Manage Participants', component: Manage_Participants},
  { path: '/eventorganizer/checked-participants', name: 'Checked Participants', component: Checked_Participants},
  { path: '/eventorganizer/question-bank', name: 'Question Bank', component: Participant_Questions },
  { path: '/eventorganizer/screen', name: 'Question Bank', component: Open_Screen },

  //Guest
  { path: `${routeConstants.GUEST_ROUTE_PATH}/profile`, name: 'Profile', component: GuestProfile },
  { path: `${routeConstants.GUEST_ROUTE_PATH}/register`, name: 'Register', component: GuestRegister },
  { path: `${routeConstants.GUEST_ROUTE_PATH}/dashboard`, name: 'Check In', component: GuestDashboard },

  //HR
  { path: `${routeConstants.HR_ROUTE_PATH}/dashboard`, name: 'QR Check-in Visitors', component: QRCheckinHistory },
  { path: `${routeConstants.HR_ROUTE_PATH}/branches`, name: 'Corporate Branches', component: HRCorpBranches },

  //Notification panel
  { path: '/notification-panel/single/create', name: 'Single User Notification', component: Single_User_Notification },
  { path: '/notification-panel/category/create', name: 'Category Notification', component: Category_Notification },

  //Space WorkSpace
  { path: '/corporate/spacetags/workspace', name: 'Work space', component: WorkSpace },
  { path: '/corporate/spacetags/notification', name: 'Notification', component: WorkSpaceNotification },

  //EventApp redirection
  // { path: `${routeConstants.EVENT_APP_REDIRECTION_ROUTE_PATH}`, name: 'Profile', component: GuestProfile }
];

export default routes;
